import { RsuiteDatePicker } from "@components/adapters/rsuite/DatePicker";
import type { DatePickerProps } from "@components/contracts/DatePicker.types";

export const DatePicker: React.FC<DatePickerProps> = (props) => (
  <RsuiteDatePicker {...props} />
);

export type { DatePickerProps };
